exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cert{direction:rtl!important}body[dir=rtl] .cert {\n  direction: ltr;\n}\n", ""]);

// exports
